// import React, { useState, useEffect, useCallback } from 'react';
// // import axios from 'axios';
// import { FaEye, FaSpinner, FaCheckCircle,FaFilter, FaSearch, FaCalendarAlt } from 'react-icons/fa';
// import { useUser } from '../UserContext';
// // import { useNavigate } from 'react-router-dom';

// const TeacherApprovedReport = () => {
//   const { user } = useUser();
//   const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();
//   // const navigate = useNavigate();

//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedPdf, setSelectedPdf] = useState(null);
//   const [pdfUrls, setPdfUrls] = useState({});
//   const [loadingPdfIds, setLoadingPdfIds] = useState({});
//   const [nameFilter, setNameFilter] = useState('');
//   const [dateFilter, setDateFilter] = useState('');
//   const [startDateFilter, setStartDateFilter] = useState('');
//   const [endDateFilter, setEndDateFilter] = useState('');
//   const [isDateRangeMode, setIsDateRangeMode] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const [filteredReports, setFilteredReports] = useState([]);

//   // Fetch both endpoints, merge, deduplicate, and filter for approved by this teacher
//   const fetchReports = useCallback(async () => {
//     if (!user?.username) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const [pendingRes, statsRes] = await Promise.all([
//         fetch(`${apiUrl}/api/get-all-report-pdfs`),
//         fetch(`${apiUrl}/api/report-stats`)
//       ]);
//       const pendingData = await pendingRes.json();
//       const statsData = await statsRes.json();
//       // Merge and deduplicate by id or registration_id
//       let allReports = [...pendingData, ...statsData];
//       const uniqueIds = new Set();
//       allReports = allReports.filter(report => {
//         const id = report.id || report.registration_id;
//         if (uniqueIds.has(id)) return false;
//         uniqueIds.add(id);
//         return true;
//       });
//       // Filter for approved by this teacher
//       const teacherApproved = allReports.filter(r => r.status === 'approved' && r.teacher_username === user.username);
//       setReports(teacherApproved);
//     } catch (err) {
//       console.error('Error fetching reports:', err);
//       setError(err.message || 'Failed to fetch reports.');
//     } finally {
//       setLoading(false);
//     }
//   }, [apiUrl, user?.username]);

//   useEffect(() => {
//     fetchReports();
//   }, [fetchReports]);

//   // Apply filters whenever filter states or reports change
//   useEffect(() => {
//     let filtered = [...reports];
//     if (nameFilter.trim()) {
//       filtered = filtered.filter(report =>
//         report.username && report.username.toLowerCase().includes(nameFilter.toLowerCase())
//       );
//     }
//     if (isDateRangeMode) {
//       if (startDateFilter) {
//         const startDate = new Date(startDateFilter);
//         startDate.setHours(0, 0, 0, 0);
//         filtered = filtered.filter(report => {
//           const reportDate = new Date(report.reported_at);
//           return reportDate >= startDate;
//         });
//       }
//       if (endDateFilter) {
//         const endDate = new Date(endDateFilter);
//         endDate.setHours(23, 59, 59, 999);
//         filtered = filtered.filter(report => {
//           const reportDate = new Date(report.reported_at);
//           return reportDate <= endDate;
//         });
//       }
//     } else {
//       if (dateFilter) {
//         const filterDate = new Date(dateFilter);
//         filtered = filtered.filter(report => {
//           const reportDate = new Date(report.reported_at);
//           return reportDate.toDateString() === filterDate.toDateString();
//         });
//       }
//     }
//     setFilteredReports(filtered);
//   }, [nameFilter, dateFilter, startDateFilter, endDateFilter, isDateRangeMode, reports]);

//   const resetFilters = () => {
//     setNameFilter('');
//     setDateFilter('');
//     setStartDateFilter('');
//     setEndDateFilter('');
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleString('en-US', {
//       year: 'numeric', month: 'long', day: 'numeric',
//       hour: '2-digit', minute: '2-digit'
//     });

//   // Toggle viewing a PDF: fetch blob if needed
//   const toggleViewPdf = async report => {
//     const id = report.id || report.registration_id;
//     if (selectedPdf === id) {
//       if (pdfUrls[id]) {
//         URL.revokeObjectURL(pdfUrls[id]);
//         setPdfUrls(u => {
//           const copy = { ...u };
//           delete copy[id];
//           return copy;
//         });
//       }
//       setSelectedPdf(null);
//       return;
//     }
//     setSelectedPdf(id);
//     if (pdfUrls[id]) return;
//     setLoadingPdfIds(ids => ({ ...ids, [id]: true }));
//     try {
//       const res = await fetch(`${apiUrl}/api/reports/${report.registration_id}/pdf`);
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const blob = await res.blob();
//       const url = URL.createObjectURL(blob);
//       setPdfUrls(u => ({ ...u, [id]: url }));
//     } catch (err) {
//       console.error('Error loading PDF:', err);
//       alert('Failed to load PDF.');
//     } finally {
//       setLoadingPdfIds(ids => ({ ...ids, [id]: false }));
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-8 px-4">
//       <div className="max-w-6xl mx-auto">
//         <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8">
//           <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6">
//             <h2 className="text-3xl font-bold text-white text-center">
//               Reports Approved By Me
//             </h2>
//           </div>
//           <div className="p-6">
//             {/* Filter UI copied from PendingReport */}
//             <div className="p-4 bg-gray-50 border-b border-gray-200 mb-4">
//               <div className="flex justify-between items-center">
//                 <button
//                   onClick={() => setShowFilters(!showFilters)}
//                   className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition"
//                 >
//                   <FaFilter /> {showFilters ? 'Hide Filters' : 'Show Filters'}
//                 </button>
//                 {reports.length > 0 && (
//                   <div className="text-gray-600">
//                     <span className="font-medium">{filteredReports.length}</span> of {reports.length} reports displayed
//                   </div>
//                 )}
//               </div>
//               {showFilters && (
//                 <div className="mt-4 space-y-4">
//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <FaSearch className="text-gray-400" />
//                       </div>
//                       <input
//                         type="text"
//                         placeholder="Filter by student name"
//                         value={nameFilter}
//                         onChange={e => setNameFilter(e.target.value)}
//                         className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
//                   <span className="text-gray-700 font-medium">Date Filter:</span>
//                   <div className="flex items-center bg-gray-200 p-1 rounded-lg">
//                     <button
//                       onClick={() => setIsDateRangeMode(false)}
//                       className={`px-3 py-1 rounded-md text-sm font-medium ${!isDateRangeMode ? 'bg-white shadow text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`}
//                     >
//                       Single Date
//                     </button>
//                     <button
//                       onClick={() => setIsDateRangeMode(true)}
//                       className={`px-3 py-1 rounded-md text-sm font-medium ${isDateRangeMode ? 'bg-white shadow text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`}
//                     >
//                       Date Range
//                     </button>
//                   </div>
//                   {isDateRangeMode ? (
//                     <>
//                       <div className="relative">
//                         <div className="absolute left-0 top-1/2 -translate-y-[18px] pl-3 flex items-center pointer-events-none">
//                           <FaCalendarAlt className="text-gray-400" />
//                         </div>
//                         <input
//                           type="date"
//                           placeholder="Start Date"
//                           value={startDateFilter}
//                           onChange={e => setStartDateFilter(e.target.value)}
//                           className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
//                         />
//                         <div className="text-xs text-gray-500 mt-1 ml-1">From</div>
//                       </div>
//                       <div className="relative">
//                         <div className="absolute left-0 top-1/2 -translate-y-[18px] pl-3 flex items-center pointer-events-none">
//                           <FaCalendarAlt className="text-gray-400" />
//                         </div>
//                         <input
//                           type="date"
//                           placeholder="End Date"
//                           value={endDateFilter}
//                           onChange={e => setEndDateFilter(e.target.value)}
//                           className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
//                         />
//                         <div className="text-xs text-gray-500 mt-1 ml-1">To</div>
//                       </div>
//                     </>
//                   ) : (
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <FaCalendarAlt className="text-gray-400" />
//                       </div>
//                       <input
//                         type="date"
//                         value={dateFilter}
//                         onChange={e => setDateFilter(e.target.value)}
//                         className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   )}
//                   <div className="flex justify-end">
//                     <button
//                       onClick={resetFilters}
//                       className="py-2 px-4 border border-gray-300 rounded-lg hover:bg-gray-100 text-gray-700 transition"
//                     >
//                       Reset All Filters
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//             {loading ? (
//               <div className="flex justify-center py-12">
//                 <FaSpinner className="animate-spin text-4xl text-blue-600" />
//               </div>
//             ) : error ? (
//               <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
//                 <strong>Error:</strong> {error}
//               </div>
//             ) : reports.length > 0 ? (
//               <div className="overflow-x-auto">
//                 <table className="min-w-full bg-white border border-gray-200">
//                   <thead>
//                     <tr className="bg-gray-50 border-b">
//                       <th className="text-left py-3 px-4 uppercase font-semibold text-sm">S.No</th>
//                       <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Date</th>
//                       <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Student Name</th>
//                       <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Patient ID</th>
//                       <th className="text-center py-3 px-4 uppercase font-semibold text-sm">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredReports.map((report, idx) => (
//                       <React.Fragment key={report.id || report.registration_id || idx}>
//                         <tr className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
//                           <td className="py-3 px-4">{idx + 1}</td>
//                           <td className="py-3 px-4">{formatDate(report.reported_at)}</td>
//                           <td className="py-3 px-4">{report.name || report.username || 'Not specified'}</td>
//                           <td className="py-3 px-4">{report.registration_id}</td>
//                           <td className="py-3 px-4 text-center">
//                             <button
//                               onClick={() => toggleViewPdf(report)}
//                               className="flex items-center justify-center gap-2 bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition mx-auto"
//                             >
//                               <FaEye /> View Report
//                             </button>
//                           </td>
//                         </tr>
//                         {selectedPdf === (report.id || report.registration_id) && (
//                           <tr>
//                             <td colSpan="5" className="border-t border-gray-200 p-4">
//                               <div className="bg-green-50 border border-green-200 p-4 rounded-lg mb-4 flex items-center">
//                                 <div className="bg-green-100 p-2 rounded-full mr-3">
//                                   <FaCheckCircle className="text-green-600 h-5 w-5" />
//                                 </div>
//                                 <div>
//                                   <h3 className="text-lg font-semibold text-green-800">
//                                     Report Approved
//                                   </h3>
//                                   <p className="text-sm text-green-700">
//                                     Approved on {formatDate(report.updated_at || report.reported_at)}
//                                   </p>
//                                 </div>
//                               </div>
//                               {loadingPdfIds[report.id || report.registration_id] ? (
//                                 <div className="flex justify-center py-12">
//                                   <FaSpinner className="animate-spin text-4xl text-blue-600" />
//                                 </div>
//                               ) : pdfUrls[report.id || report.registration_id] ? (
//                                 <iframe
//                                   src={pdfUrls[report.id || report.registration_id]}
//                                   className="w-full h-[500px] mb-6 border border-gray-200 rounded"
//                                   title={`PDF Report ${report.id || report.registration_id}`}
//                                 />
//                               ) : (
//                                 <div className="flex justify-center py-12">
//                                   <FaSpinner className="animate-spin text-4xl text-green-600" />
//                                 </div>
//                               )}
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             ) : (
//               <div className="text-center py-12">
//                 <h2 className="text-xl font-semibold text-gray-600">
//                   No approved reports found
//                 </h2>
//                 <p className="text-gray-500">You have not approved any reports yet.</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TeacherApprovedReport; 

import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FaEye, FaSpinner, FaCheckCircle,FaFilter, FaSearch, FaCalendarAlt } from 'react-icons/fa';
import { useUser } from '../UserContext';
// import { useNavigate } from 'react-router-dom';

const TeacherApprovedReport = () => {
  const { user } = useUser();
  const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();
  // const navigate = useNavigate();

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [pdfUrls, setPdfUrls] = useState({});
  const [loadingPdfIds, setLoadingPdfIds] = useState({});
  const [nameFilter, setNameFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [startDateFilter, setStartDateFilter] = useState('');
  const [endDateFilter, setEndDateFilter] = useState('');
  const [isDateRangeMode, setIsDateRangeMode] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filteredReports, setFilteredReports] = useState([]);
  const [quizScores, setQuizScores] = useState({});

  // Fetch both endpoints, merge, deduplicate, and filter for approved by this teacher
  const fetchReports = useCallback(async () => {
    if (!user?.username) return;
    setLoading(true);
    setError(null);
    try {
      const [pendingRes, statsRes] = await Promise.all([
        fetch(`${apiUrl}/api/get-all-report-pdfs`),
        fetch(`${apiUrl}/api/report-stats`)
      ]);
      const pendingData = await pendingRes.json();
      const statsData = await statsRes.json();
      // Merge and deduplicate by id or registration_id
      let allReports = [...pendingData, ...statsData];
      const uniqueIds = new Set();
      allReports = allReports.filter(report => {
        const id = report.id || report.registration_id;
        if (uniqueIds.has(id)) return false;
        uniqueIds.add(id);
        return true;
      });
      // Filter for approved by this teacher
      const teacherApproved = allReports.filter(r => r.status === 'approved' && r.teacher_username === user.username);
      setReports(teacherApproved);
    } catch (err) {
      console.error('Error fetching reports:', err);
      setError(err.message || 'Failed to fetch reports.');
    } finally {
      setLoading(false);
    }
  }, [apiUrl, user?.username]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  // Apply filters whenever filter states or reports change
  useEffect(() => {
    let filtered = [...reports];
    if (nameFilter.trim()) {
      filtered = filtered.filter(report =>
        report.username && report.username.toLowerCase().includes(nameFilter.toLowerCase())
      );
    }
    if (isDateRangeMode) {
      if (startDateFilter) {
        const startDate = new Date(startDateFilter);
        startDate.setHours(0, 0, 0, 0);
        filtered = filtered.filter(report => {
          const reportDate = new Date(report.reported_at);
          return reportDate >= startDate;
        });
      }
      if (endDateFilter) {
        const endDate = new Date(endDateFilter);
        endDate.setHours(23, 59, 59, 999);
        filtered = filtered.filter(report => {
          const reportDate = new Date(report.reported_at);
          return reportDate <= endDate;
        });
      }
    } else {
      if (dateFilter) {
        const filterDate = new Date(dateFilter);
        filtered = filtered.filter(report => {
          const reportDate = new Date(report.reported_at);
          return reportDate.toDateString() === filterDate.toDateString();
        });
      }
    }
    setFilteredReports(filtered);
  }, [nameFilter, dateFilter, startDateFilter, endDateFilter, isDateRangeMode, reports]);

  const resetFilters = () => {
    setNameFilter('');
    setDateFilter('');
    setStartDateFilter('');
    setEndDateFilter('');
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });

  // Toggle viewing a PDF: fetch blob if needed
  const toggleViewPdf = async report => {
    const id = report.id || report.registration_id;
    if (selectedPdf === id) {
      if (pdfUrls[id]) {
        URL.revokeObjectURL(pdfUrls[id]);
        setPdfUrls(u => {
          const copy = { ...u };
          delete copy[id];
          return copy;
        });
      }
      setSelectedPdf(null);
      return;
    }
    setSelectedPdf(id);
    if (pdfUrls[id]) return;
    setLoadingPdfIds(ids => ({ ...ids, [id]: true }));
    try {
      const res = await fetch(`${apiUrl}/api/reports/${report.registration_id}/pdf`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setPdfUrls(u => ({ ...u, [id]: url }));
    } catch (err) {
      console.error('Error loading PDF:', err);
      alert('Failed to load PDF.');
    } finally {
      setLoadingPdfIds(ids => ({ ...ids, [id]: false }));
    }
  };

  // Fetch quiz score for a registrationId
  const fetchQuizScore = async (registrationId) => {
    if (!registrationId || quizScores[registrationId]?.loading || quizScores[registrationId]?.percentage !== undefined) return;
    setQuizScores(prev => ({ ...prev, [registrationId]: { loading: true } }));
    try {
      const res = await axios.get(`${apiUrl}/api/quiz-scores/${registrationId}`);
      const percentage = Array.isArray(res.data) && res.data.length > 0 ? res.data[0].percentage : undefined;
      setQuizScores(prev => ({ ...prev, [registrationId]: { loading: false, percentage } }));
    } catch (err) {
      setQuizScores(prev => ({ ...prev, [registrationId]: { loading: false, percentage: undefined } }));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6">
            <h2 className="text-3xl font-bold text-white text-center">
              Reports Approved By Me
            </h2>
          </div>
          <div className="p-6">
            {/* Filter UI copied from PendingReport */}
            <div className="p-4 bg-gray-50 border-b border-gray-200 mb-4">
              <div className="flex justify-between items-center">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition"
                >
                  <FaFilter /> {showFilters ? 'Hide Filters' : 'Show Filters'}
                </button>
                {reports.length > 0 && (
                  <div className="text-gray-600">
                    <span className="font-medium">{filteredReports.length}</span> of {reports.length} reports displayed
                  </div>
                )}
              </div>
              {showFilters && (
                <div className="mt-4 space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FaSearch className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        placeholder="Filter by student name"
                        value={nameFilter}
                        onChange={e => setNameFilter(e.target.value)}
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  <span className="text-gray-700 font-medium">Date Filter:</span>
                  <div className="flex items-center bg-gray-200 p-1 rounded-lg">
                    <button
                      onClick={() => setIsDateRangeMode(false)}
                      className={`px-3 py-1 rounded-md text-sm font-medium ${!isDateRangeMode ? 'bg-white shadow text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`}
                    >
                      Single Date
                    </button>
                    <button
                      onClick={() => setIsDateRangeMode(true)}
                      className={`px-3 py-1 rounded-md text-sm font-medium ${isDateRangeMode ? 'bg-white shadow text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`}
                    >
                      Date Range
                    </button>
                  </div>
                  {isDateRangeMode ? (
                    <>
                      <div className="relative">
                        <div className="absolute left-0 top-1/2 -translate-y-[18px] pl-3 flex items-center pointer-events-none">
                          <FaCalendarAlt className="text-gray-400" />
                        </div>
                        <input
                          type="date"
                          placeholder="Start Date"
                          value={startDateFilter}
                          onChange={e => setStartDateFilter(e.target.value)}
                          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                        />
                        <div className="text-xs text-gray-500 mt-1 ml-1">From</div>
                      </div>
                      <div className="relative">
                        <div className="absolute left-0 top-1/2 -translate-y-[18px] pl-3 flex items-center pointer-events-none">
                          <FaCalendarAlt className="text-gray-400" />
                        </div>
                        <input
                          type="date"
                          placeholder="End Date"
                          value={endDateFilter}
                          onChange={e => setEndDateFilter(e.target.value)}
                          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                        />
                        <div className="text-xs text-gray-500 mt-1 ml-1">To</div>
                      </div>
                    </>
                  ) : (
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FaCalendarAlt className="text-gray-400" />
                      </div>
                      <input
                        type="date"
                        value={dateFilter}
                        onChange={e => setDateFilter(e.target.value)}
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  )}
                  <div className="flex justify-end">
                    <button
                      onClick={resetFilters}
                      className="py-2 px-4 border border-gray-300 rounded-lg hover:bg-gray-100 text-gray-700 transition"
                    >
                      Reset All Filters
                    </button>
                  </div>
                </div>
              )}
            </div>
            {loading ? (
              <div className="flex justify-center py-12">
                <FaSpinner className="animate-spin text-4xl text-blue-600" />
              </div>
            ) : error ? (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
                <strong>Error:</strong> {error}
              </div>
            ) : reports.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                  <thead>
                    <tr className="bg-gray-50 border-b">
                      <th className="text-left py-3 px-4 uppercase font-semibold text-sm">S.No</th>
                      <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Date</th>
                      <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Student Name</th>
                      <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Patient ID</th>
                      <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Score</th>
                      <th className="text-center py-3 px-4 uppercase font-semibold text-sm">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredReports.map((report, idx) => (
                      <React.Fragment key={report.id || report.registration_id || idx}>
                        <tr className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                          <td className="py-3 px-4">{idx + 1}</td>
                          <td className="py-3 px-4">{formatDate(report.reported_at)}</td>
                          <td className="py-3 px-4">{report.name || report.username || 'Not specified'}</td>
                          <td className="py-3 px-4">{report.registration_id}</td>
                          <td className="py-3 px-4 text-sm text-gray-700">
                            {(() => {
                              const regId = report.registration_id;
                              if (!regId) return '-';
                              if (!quizScores[regId]) fetchQuizScore(regId);
                              const scoreObj = quizScores[regId];
                              if (!scoreObj || scoreObj.loading) return <FaSpinner className="animate-spin text-blue-500 inline-block" />;
                              if (scoreObj.percentage === undefined || scoreObj.percentage === null) return '-';
                              let bgColor, textColor;
                              if (scoreObj.percentage >= 80) {
                                bgColor = 'bg-green-100';
                                textColor = 'text-green-700';
                              } else if (scoreObj.percentage >= 60) {
                                bgColor = 'bg-yellow-100';
                                textColor = 'text-yellow-700';
                              } else {
                                bgColor = 'bg-red-100';
                                textColor = 'text-red-700';
                              }
                              return (
                                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${bgColor} ${textColor}`}>
                                  {scoreObj.percentage}%
                                </span>
                              );
                            })()}
                          </td>
                          <td className="py-3 px-4 text-center">
                            <button
                              onClick={() => toggleViewPdf(report)}
                              className="flex items-center justify-center gap-2 bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition mx-auto"
                            >
                              <FaEye /> View Report
                            </button>
                          </td>
                        </tr>
                        {selectedPdf === (report.id || report.registration_id) && (
                          <tr>
                            <td colSpan="6" className="border-t border-gray-200 p-4">
                              <div className="bg-green-50 border border-green-200 p-4 rounded-lg mb-4 flex items-center">
                                <div className="bg-green-100 p-2 rounded-full mr-3">
                                  <FaCheckCircle className="text-green-600 h-5 w-5" />
                                </div>
                                <div>
                                  <h3 className="text-lg font-semibold text-green-800">
                                    Report Approved
                                  </h3>
                                  <p className="text-sm text-green-700">
                                    Approved on {formatDate(report.updated_at || report.reported_at)}
                                  </p>
                                </div>
                              </div>
                              {loadingPdfIds[report.id || report.registration_id] ? (
                                <div className="flex justify-center py-12">
                                  <FaSpinner className="animate-spin text-4xl text-blue-600" />
                                </div>
                              ) : pdfUrls[report.id || report.registration_id] ? (
                                <iframe
                                  src={pdfUrls[report.id || report.registration_id]}
                                  className="w-full h-[500px] mb-6 border border-gray-200 rounded"
                                  title={`PDF Report ${report.id || report.registration_id}`}
                                />
                              ) : (
                                <div className="flex justify-center py-12">
                                  <FaSpinner className="animate-spin text-4xl text-blue-600" />
                                </div>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-12">
                <h2 className="text-xl font-semibold text-gray-600">
                  No approved reports found
                </h2>
                <p className="text-gray-500">You have not approved any reports yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherApprovedReport;